/**
 * Id do elemento da evidência na tela da atividade, usado como âncora.
 *
 * Fica em um helper porque duas telas dependem do mesmo valor: a listagem de controles do documento
 * monta o hash da URL e a tela da atividade renderiza o elemento com esse id. Se cada lado montasse o
 * seu, uma mudança em um deles quebraria a navegação silenciosamente.
 */
const mountEvidenceAnchor = (evidenceId) =>
  evidenceId ? `evidence-${evidenceId}` : ''

export default mountEvidenceAnchor
